module.exports = __webpack_public_path__ + "media/img/feature-icon-confirmation-9788e9ce41ddf9bf6805cdd3ddff082d.svg";